export default {
  methods: {
    locationReplace(url) {
      window.location.href = url;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/locations.js